import React from 'react';

interface BrandData {
  name: string;
  amount: number;
}

interface TopBrandsChartProps {
  outletsData: BrandData[];
}

const TopBrandsChart: React.FC<TopBrandsChartProps> = ({ outletsData }) => (
  <ul className="divide-y divide-gray-200 bg-white rounded-lg max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
    {outletsData.map((outlet, index) => (
      <li
        key={index}
        className="flex justify-between items-center px-4 py-2 text-sm"
      >
        <span className="truncate">{outlet.name}</span>
        <span className="font-medium">{outlet.amount.toLocaleString()}</span>
      </li>
    ))}
  </ul>
);

export default TopBrandsChart; 